import classes from "../../scss/ServiceSlide.module.scss";

export default function Slide({ children, className = "" }) {
  return (
    <section className={`${classes.slide || ""} ${className}`}>
      {children}
    </section>
  );
}
